import { render, staticRenderFns } from "./MimecastMailWizard.vue?vue&type=template&id=aa5c69f6&"
import script from "./MimecastMailWizard.vue?vue&type=script&lang=js&"
export * from "./MimecastMailWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports